export function getComputedStylePropertyValue(
  propertyName,
  root = document.body,
) {
  return window.getComputedStyle(root).getPropertyValue(propertyName).trim()
}
